import {Map as olMap, View as olView} from 'ol'
import {Tile as ollayerTile} from 'ol/layer'
import {XYZ as olsourceXYZ} from 'ol/source'
import 'ol-proj'
import { Coordinate } from 'ol/coordinate'
import { Extent } from 'ol/extent'
import { Renderer } from './Renderer'
import Style from 'ol/style/Style'
import { Styles } from '@/Styles'

abstract class MapBoxRenderer extends Renderer<olsourceXYZ> {
  map: olMap;
  layer: ollayerTile<olsourceXYZ>;
  projection = "EPSG:3857";

  static IsValidForExtent(latLngExtent: Extent) {
    return true
  }

  constructor(type: string, style: string, element: string, extentLatLng: Extent, mapboxApiKey: string) {
    super(type)
    this.type = type
    this.layer = new ollayerTile({
      source: new olsourceXYZ({
        url: `https://api.mapbox.com/styles/v1/mapbox/${style}/tiles/256/{z}/{x}/{y}?access_token=${mapboxApiKey}`
      })
    });
    //this.layer
    this.map = this.CreateMap(element, extentLatLng);
  }

  CreateView(centre: Coordinate): olView {
    return new olView({
      projection: this.projection,
      center: centre,
      zoom: 7,
      maxZoom: 22
    });
  }
}

export class MapBoxDefaultRenderer extends MapBoxRenderer {
  constructor(type: string, element: string, extentLatLng: Extent, mapboxApiKey: string) {
    super(type, "outdoors-v11", element, extentLatLng, mapboxApiKey)
  }
} // 'outdoors-v11' is virtually the same as 'streets-v11' - but probably better in some cases

export class MapBoxSatelliteRenderer extends MapBoxRenderer {
  constructor(type: string, element: string, extentLatLng: Extent, mapboxApiKey: string) {
    super(type, "satellite-v9", element, extentLatLng, mapboxApiKey)
  }
}
export class MapBoxSatelliteStreetsRenderer extends MapBoxRenderer {
  constructor(type: string, element: string, extentLatLng: Extent, mapboxApiKey: string) {
    super(type, "satellite-streets-v11", element, extentLatLng, mapboxApiKey)
  }
}
